import { useState, useEffect, useCallback } from 'react';
import holidayApiInstance from '../../services/Holiday/holidayApi';

// 공휴일 데이터를 관리하는 커스텀 Hook
export const useHolidays = (years = []) => {
    const [holidays, setHolidays] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchHolidays = useCallback(async () => {
        if (years.length === 0) return;

        setLoading(true);
        setError(null);

        try {
        const holidayData = await holidayApiInstance.getHolidaysForYears(years);
        setHolidays(holidayData);
        } catch (err) {
        setError(err);
        console.error('공휴일 데이터 로드 실패:', err);
        } finally {
        setLoading(false);
        }
    }, [years]);

    useEffect(() => {
        fetchHolidays();
    }, [fetchHolidays]);

    // 특정 날짜가 공휴일인지 확인하는 함수
    const isHoliday = useCallback((date) => {
        return holidayApiInstance.isHoliday(date, holidays);
    }, [holidays]);

    // 주말 및 공휴일 체크 함수
    const isWeekendOrHoliday = useCallback((date) => {
        const dayOfWeek = date.day();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6; // 일요일(0) 또는 토요일(6)
        return isWeekend || isHoliday(date);
    }, [isHoliday]);

    return {
        holidays,
        loading,
        error,
        isHoliday,
        isWeekendOrHoliday,
        refetch: fetchHolidays
    };
};